import { render } from "./PageHeaderAccountMenu.vue?vue&type=template&id=1780653b"
import script from "./PageHeaderAccountMenu.vue?vue&type=script&lang=js"
export * from "./PageHeaderAccountMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__